import { render, staticRenderFns } from "./PagesFeaturedPlacesInNorwayWidget.vue?vue&type=template&id=49504a15&"
import script from "./PagesFeaturedPlacesInNorwayWidget.vue?vue&type=script&lang=js&"
export * from "./PagesFeaturedPlacesInNorwayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports